module.exports = __webpack_public_path__ + "img/tesla_900.d6e13f1b.png";